/**
 * Base class used to represent the result of an action
 */
export abstract class ActionResult {
    // Do nothing
}
